import React from 'react';
import { Link } from 'react-router-dom';

const About = () => {
  return (
    <>
      {/* Hero Section */}
      <section className="page-hero">
        <div className="container">
          <h1>About ZIRAYA Institute</h1>
        </div>
      </section>

      {/* New Institutional Description */}
      <section className="mission-section">
        <div className="container">
          <div className="institutional-content">
            <p className="lead">
              ZIRAYA Institute is a research, advocacy, and innovation hub focused on strengthening creative ecosystems across Africa.
            </p>

            <p className="institutional-text">
              We investigate the conditions that enable or hinder creative practitioners from thriving, with particular attention to safeguarding, sustainability, inclusion, accessibility, neurodiversity, emerging technologies, and the future of creative work.
            </p>

            <p className="institutional-text">
              Our work tracks trends, experiences, and systemic challenges within the creative sector, generating evidence that helps artists, institutions, policymakers, educators, funders, and communities better understand the realities shaping creative practice today.
            </p>
          </div>
        </div>
      </section>

      {/* Key Questions */}
      <section className="questions-section">
        <div className="container">
          <h2 className="section-title-centered">We are particularly interested in questions such as:</h2>
          <div className="questions-grid">
            <div className="question-item">
              <span className="question-icon">❓</span>
              <p>What makes a creative career sustainable?</p>
            </div>
            <div className="question-item">
              <span className="question-icon">❓</span>
              <p>How safe and inclusive are creative spaces?</p>
            </div>
            <div className="question-item">
              <span className="question-icon">❓</span>
              <p>What barriers prevent artists from fully participating and thriving?</p>
            </div>
            <div className="question-item">
              <span className="question-icon">❓</span>
              <p>How are emerging technologies, including artificial intelligence, reshaping creative work?</p>
            </div>
            <div className="question-item">
              <span className="question-icon">❓</span>
              <p>How can institutions better support diverse forms of creativity and participation?</p>
            </div>
            <div className="question-item">
              <span className="question-icon">❓</span>
              <p>What systems, policies, and practices are needed to build healthier creative ecosystems?</p>
            </div>
          </div>
          <div className="questions-cta">
            <p className="institutional-text">
              Beyond research, ZIRAYA develops practical responses to the challenges it identifies. These include toolkits, training programmes, policy recommendations, artistic experiments, community engagement initiatives, and collaborative projects designed to close gaps between creative potential and creative reality.
            </p>
            <p className="institutional-text" style={{ fontWeight: '500', fontSize: '1.2rem' }}>
              Our goal is simple:
            </p>
            <p className="institutional-text" style={{ fontStyle: 'italic', borderLeft: '4px solid var(--accent-cyan)', paddingLeft: '1.5rem' }}>
              To help build creative ecosystems where artists, cultural workers, and creative communities are safer, better supported, more inclusive, and more capable of sustaining meaningful careers and creative lives.
            </p>
          </div>
        </div>
      </section>

      {/* Key Initiatives Section */}
      <section className="focus-areas bg-dark">
        <div className="container">
          <h2 className="section-title-centered">Key Initiatives</h2>

          <div className="focus-grid">
            {/* From Survival to Sustainability */}
            <div className="focus-card highlight-card">
              <h3>From Survival to Sustainability</h3>
              <p>An ongoing research project examining the long-term sustainability of Kenya's performing arts ecosystem. Through interviews, archival research, policy analysis, and practitioner engagement, the project explores artist livelihoods, institutional memory, mentorship, audience development, documentation, inclusion, and the systems required to support thriving creative careers.</p>
              <p>The study seeks to contribute practical recommendations for strengthening Kenya's cultural sector while preserving the knowledge, histories, and practices that sustain artistic communities.</p>
              <div className="card-actions">
                <Link to="/journal/from-survival-to-sustainability" className="text-link">Read More →</Link>
              </div>
            </div>

            {/* Msichana wa AI */}
            <div className="focus-card highlight-card">
              <h3>Msichana wa AI</h3>
              <p>A research and creative exploration examining how African women interact with, influence, and imagine futures with artificial intelligence. The initiative combines research, storytelling, artistic experimentation, and public dialogue to investigate technology, gender, creativity, and inclusion.</p>
              <div className="card-actions">
                <Link to="/journal/msichana-wa-ai" className="text-link">Read More →</Link>
                <a href="mailto:partnerships@zirayainstitute.org?subject=Msichana%20wa%20AI%20Collaboration" className="text-link" style={{ marginLeft: '1rem' }}>Collaborate →</a>
              </div>
            </div>

            {/* Fichua Pazia */}
            <div className="focus-card highlight-card">
              <h3>Fichua Pazia</h3>
              <p>A safeguarding initiative focused on workplace safety, accountability, equity, and ethical practice within the creative sector. Through research, training, policy development, and advocacy, Fichua Pazia works to strengthen safer and more respectful creative environments.</p>
              <div className="card-actions">
                <Link to="/project/fichua-pazia-unmask" className="text-link">Learn More →</Link>
                <a
                  href="/downloads/fichua-pazia-toolkit.pdf"
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="btn btn-small"
                  style={{ marginLeft: '1rem' }}
                >
                  View Toolkit
                </a>
              </div>
            </div>

            {/* NeuroArts */}
            <div className="focus-card highlight-card">
              <h3>NeuroArts</h3>
              <p>An emerging programme supporting neurodivergent creatives through research, advocacy, mentorship, and inclusive creative practice. NeuroArts explores how creative ecosystems can better recognise, accommodate, and benefit from cognitive diversity.</p>
              <div className="card-actions">
                <Link to="/journal/neuro-arts" className="text-link">Read More →</Link>
                <Link to="/project/spectrum-creatives" className="text-link" style={{ marginLeft: '1rem' }}>Participate →</Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;